module.exports = __webpack_public_path__ + "static/img/2.46cc3c54.jpg";